import { useTranslation } from "react-i18next";
import CompareStripedRows from "./CompareStripedRows";
import lookupTables from "../../data/lookup_tables.json"
import { V1Clinic } from "../../types/v1_schemas";

function LanguagesTable({
  providerA,
  providerB,
}: {
  providerA: V1Clinic;
  providerB: V1Clinic;
}) {
  const { t } = useTranslation();

  if (!providerA.clinicServicesProvideds && !providerB.clinicServicesProvideds) {
    return <></>;
  }

  const rowData = lookupTables.languages?.map((m) => {
    return {
      label: t(`${m.lineageText}`),
      compareA: !!providerA.clinicLanguageUseds?.filter(f => f.lineageText === t(m.lineageText))[0],
      compareB: !!providerB.clinicLanguageUseds?.filter(f => f.lineageText === t(m.lineageText))[0]
    };
  });

  return (
    <CompareStripedRows
      rows={rowData}
      title={t("languagesSpoken")}
      hideEmptyRows
    />
  );
}

export default LanguagesTable;
